<template>
    <div>
        <h2>Manage Images & Videos</h2>

        <form @submit.prevent="uploadImage">
            <div>
                <label for="imageName">Asset Name:</label>
                <input v-model="imageName" id="imageName" required />
            </div>
            <div>
                <label for="imageFile">Select File:</label>
                <input type="file" @change="onFileChange" accept="image/*,video/*" required />
            </div>
            <button type="submit">Upload File</button>
        </form>

        <hr />

        <h3>Uploaded Assets</h3>
        <div class="images-grid">
            <div v-for="image in images" :key="image.name" class="image-item">

                <video v-if="isVideo(image.url)" :src="image.url" controls preload="metadata"
                    class="media-preview"></video>

                <img v-else :src="image.url" :alt="image.name" class="media-preview" />

                <p><strong>Name:</strong> {{ image.name }}</p>
                <p><strong>Path:</strong> {{ image.url }}</p>
                <button @click="copyToClipboard(image.url)">Copy Path</button>
                <button @click="confirmDelete(image.name)">Delete</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imageName: "",
            imageFile: null,
            images: [], // Retaining original name to match your API mapping
        };
    },
    methods: {
        async uploadImage() {
            if (!this.imageFile) {
                alert("Please select a file to upload.");
                return;
            }

            const formData = new FormData();
            // MATCH THE CONTROLLER: Use 'mediaName' and 'projectCode' strings
            formData.append("mediaName", this.imageName);
            formData.append("projectCode", "test"); // Replace "test" with your dynamic project code reference if applicable
            formData.append("file", this.imageFile);

            try {
                const response = await this.$http.post("/api/media/images/upload", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });

                // Backend returns { url: "/projectCode/mediaName" }
                // We push a mock object matching your grid display iteration needs
                this.images.push({
                    name: this.imageName,
                    url: response.data.url.startsWith('http')
                        ? response.data.url
                        : `${window.location.origin}${response.data.url}` // fallback path logic
                });

                alert("Asset uploaded successfully!");
                this.imageName = "";
                this.imageFile = null;
                await this.fetchImages(); // Refresh to catch actual Supabase publicUrls
            } catch (error) {
                console.error("Error uploading asset:", error);
                alert("Failed to upload asset.");
            }
        },
        onFileChange(event) {
            this.imageFile = event.target.files[0];
        },
        async fetchImages() {
            try {
                const response = await this.$http.get("/api/media/images");
                this.images = response.data;
            } catch (error) {
                console.error("Error fetching assets:", error);
            }
        },
        async deleteImage(name) {
            try {
                await this.$http.delete(`/api/media/images/${name}`);
                this.images = this.images.filter((image) => image.name !== name);
                this.$emit("imageDeleted");
            } catch (error) {
                console.error("Error deleting asset:", error);
                alert("Failed to delete asset.");
            }
        },
        confirmDelete(name) {
            if (confirm(`Are you sure you want to delete "${name}"?`)) {
                this.deleteImage(name);
            }
        },
        copyToClipboard(text) {
            navigator.clipboard
                .writeText(text)
                .then(() => alert("Path copied to clipboard!"))
                .catch((err) => console.error("Failed to copy path:", err));
        },
        // NEW: Helper method to sniff the URL for video formats
        isVideo(url) {
            if (!url) return false;
            const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.m4v'];
            return videoExtensions.some(ext => url.toLowerCase().includes(ext));
        }
    },
    async mounted() {
        await this.fetchImages();
    },
};
</script>

<style scoped>
.images-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.image-item {
    text-align: center;
    width: 200px;
}

/* CHANGED: Made the preview styling abstract to neatly containerize both img and video */
.media-preview {
    max-width: 100%;
    height: 150px;
    object-fit: cover;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: #000;
    /* Dark canvas backings keep video layouts clean if aspect ratios vary */
}

.image-item p {
    margin: 5px 0;
}

button {
    margin: 5px 0;
}
</style>